<template>
    <div class="comparing-img">
        <div v-if="images.length !== 0"
             class="bg-ratio bg-ratio--4-3"
             :style="`background-image: url('/image/fetch/${images[0]}')`"
        ></div>
        <div v-else class="loading-spinner"></div>


        <div class="comparing-img__thumbs">
            <div v-for="image in images"
                 class="bg-ratio bg-ratio--4-3 m-1"
                 :style="`background-image: url('/image/fetch/${image}')`"
            ></div>
        </div>
    </div>
</template>

<script>

export default {
    name: "thumbnails-adverts",
    props: ['record', 'noImage'],
    data: function () {
        return {
            images: []
        }
    },
    created() {
        let self = this;
        $.ajax({
            url: "/realty/ajax/images/" + this.record,
        }).done(function (data) {
            self.images = JSON.parse(data).slice(0, 3);
        });
    },
}
</script>

<style scoped>
.loading-spinner:before {
    top: 30px !important;
    left: 50% !important;
}
</style>
